/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Represents an attachment which was deleted from an entity.
 */
export class DeletedAttachment {
  constructor(json: JSON | any) {
    Object.assign(this as DeletedAttachment, json)
  }

  /**
   * If the attachment was stored as a couchdb attachment this holds the id of the attachment, else null.
   */
  couchDbAttachmentId?: string
  /**
   * If the attachment was stored using the object storage service this holds the id of the attachment, else null.
   */
  objectStoreAttachmentId?: string
  /**
   * If the attachment was associated to a key this was its key, else null.
   */
  key?: string

  /**
   * Instant the attachment was deleted, as epoch timestamp in ms.
   */
  deletionTime?: number
}
